import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SignatureCanvas from 'react-signature-canvas';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { formatDate } from '../../util/dates';
import { parse } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Button,
  ExternalLink,
  IconCheckmark,
} from '../../components';

import { loadData, signProtocol } from './SignaturePage.duck';

import css from './SignaturePage.css';

const SignaturePage = (props) => {
  const { intl } = props;
  const dispatch = useDispatch();
  const { protocolData, signProtocolInProgress, signProtocolSuccess, signProtocolError } = useSelector(state => state.SignaturePage);
  const { tx, page, protocolKey } = parse(props.location.search);
  const sigCanvas = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  function clear() {
    sigCanvas.current.clear();
    setIsEmpty(true)
  }

  function save() {
    sigCanvas.current.getTrimmedCanvas().toBlob((blob) => {
      dispatch(signProtocol({
        file: blob,
        page,
        txId: tx,
        key: protocolKey
      }))
    })
  }


  return (
    <StaticPage
      title={intl.formatMessage({ id: 'SignaturePage.pageTitle' })}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'SignaturePage',
        description: intl.formatMessage({ id: 'SignaturePage.pageTitle' }),
        name: intl.formatMessage({ id: 'SignaturePage.pageTitle' }),
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div>
            <h2>Wypozyczenie {protocolData?.code}</h2>
            <h3>{protocolData?.providerName}</h3>
            <div>
              <div>Klient: {protocolData?.clientName}</div>
              <div>Odbierający: {protocolData?.receiverName}</div>
              <div>{protocolData?.listings.map(l => <div>{l.title} x {l.seats}</div>)}</div>
              <div>{intl.formatDate(protocolData?.start, { day: 'numeric', month: 'long', year: 'numeric' })} - {intl.formatDate(protocolData?.end, { day: 'numeric', month: 'long', year: 'numeric' })}</div>
              <a href={`${protocolData?.protocolLink}`} target="_blank">Podgląd protokołu</a>
            </div>
            <div className={css.sigContainer}>
              Podpisz protokół ({page === 'pickup' ? "odbiór sprzętu" : "zwrot sprzętu"})
              <div className={css.signatureField}>
                {signProtocolSuccess && <div className={css.signatureSuccess}>
                  <div><IconCheckmark className={css.success} size="big" /></div>
                  <div>Protokół został podpisany</div>
                </div>}
                {
                  signProtocolError && (
                    <div className={css.signatureError}>
                      <div>Protokół nie został podpisany</div>
                      <div>{signProtocolError.title}</div>
                    </div>
                  )
                }
                <SignatureCanvas
                  penColor="#3643BA"
                  canvasProps={{ className: css.sigCanvas }}
                  ref={sigCanvas}
                  onEnd={() => setIsEmpty(false)}
                />
              </div>
              <div className={css.buttonsContainer}>
                <Button className={css.buttons} onClick={clear}>Wyczyść</Button>
                <Button className={css.buttons} inProgress={signProtocolInProgress} onClick={save} disabled={isEmpty || signProtocolInProgress || signProtocolSuccess}>Podpisz</Button>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

SignaturePage.loadData = loadData;

export default withRouter(injectIntl(SignaturePage));
